<template>
  <div class="main-take-picture">
    <f7-block class="content-select-picture">
      <div class="content-select-picture__title">
        Agregar fotografía
      </div>
      <div
        v-if="imageSrc.length > 0"
        class="content-select-picture__gallery margin"
      >
        <f7-swiper
          :key="numPictures"
          pagination
        >
          <f7-swiper-slide
            v-for="(element, index) in imageSrc"
            :key="index"
          >
            <img
              :src="element"
              class="lazy lazy-fade-in demo-lazy photo-scouting"
              @click="deleteElement(index)"
            >
          </f7-swiper-slide>
        </f7-swiper>
      </div>

      <!-- Take Picture -->
      <div
        class="content-select-picture__add-img padding-vertical-half margin-horizontal margin-top"
        @click="openSheet()"
      >
        <img
          :src="cameraAddIcon"
        >
      </div>
    </f7-block>
    <!-- Input File  selector from Web navigator hidden -->
    <input
      ref="fileInput"
      type="file"
      accept=".jpg"
      hidden
      @input="onSelectFileBrowser"
    >
    <!-- Action Sheet -->
    <f7-sheet
      class="demo-sheet"
      :opened="sheetOpened"
      @sheet:closed="sheetOpened = false"
    >
      <f7-page-content class="content-action-sheet padding-vertical-half">
        <div class="content-action-sheet__title text-align-center">
          {{ $t('common.selectAnOption') }}
        </div>
        <div class="content-action-sheet__actions">
          <div
            v-if="cordovaDevice"
            class="text-align-center content-action-sheet__actions--camera"
          >
            <img
              :src="cameraIcon"
              @click="cameraTakePicture(true)"
            >
            <span>
              {{ $t('common.camera') }}
            </span>
          </div>
          <div class="text-align-center content-action-sheet__actions--gallery">
            <img
              :src="galleryIcon"
              @click="cameraTakePicture(false)"
            >
            <span>
              {{ $t('common.gallery') }}
            </span>
          </div>
        </div>
      </f7-page-content>
    </f7-sheet>
  </div>
</template>

<script>
import { isDeviceCordova } from '@/js/utils/platform';
import cameraIcon from '@/static/img/ic_camera.svg';
import cameraAddIcon from '@/static/img/ic_camera_add.svg';
import galleryIcon from '@/static/img/ic_gallery.svg';
import { ConfirmDialogGH, HiNotification } from '@/js/common/HINotificationSupport';

export default {
  name: 'TakePicture',
  props: {
    images: { type: Array, default: () => [] },
  },

  emits: ['images-changed'],

  data() {
    return {
      imageSrc: [],
      numPictures: 0,
      pictures: [],
      sheetOpened: false,
    };
  },
  computed: {
    cameraIcon: () => cameraIcon,
    galleryIcon: () => galleryIcon,
    cameraAddIcon: () => cameraAddIcon,
    cordovaDevice: () => isDeviceCordova(), // Funciona en un dispositivo o en un navegador.
  },

  watch: {
    images(val) {
      if (this.imageSrc.length === 0) {
        this.imageSrc = val;
        this.numPictures = val.length || 0;
      }
    },
  },
  methods: {
    // Al hacer click en una imagen, esta se podrá eliminar
    async deleteElement(index) {
      const res = await ConfirmDialogGH(`${this.$t('ConfirmarEliminacion')}`);

      if (res) {
        const newPictures = this.pictures;
        newPictures.splice(index, 1);
        this.numPictures -= 1;
        this.imageSrc.splice(index, 1);
        this.emitImages();
      }
    },
    setOptions(srcType) {
      const options = {
        quality: 100, // % of quality to save

        // eslint-disable-next-line no-undef
        destinationType: Camera.DestinationType.FILE_URI, // DATA_URL (base 64), FILE_URI (android), NATIVE_URI (iOS)
        sourceType: srcType,
        encodingType: 0, // JPEG, PNG
        mediaType: 0, // PICTURE, VIDEO, ALLMEDIA (Picture and Video)
        allowEdit: false, // Allow to edit before save picture
        correctOrientation: true, // Corrects Android orientation quirks
        targetHeight: 1920, // Se usa para redimensionar la imagen (valor en px)
        targetWidth: 1080, // Se usa para redimensionar la imagen (valor en px)
      };
      return options;
    },

    cameraTakePicture(getFromGalery) {
      this.sheetOpened = false;
      if (!this.cordovaDevice) {
        this.browserGetPicture();
        return;
      }
      let srcType;
      // Options: PHOTOLIBRARY / CAMERA / SAVEDPHOTOALBUM
      if (getFromGalery) {
        srcType = 1;
      } else {
        srcType = 0;
      }
      const options = this.setOptions(srcType);
      if (this.pictures.length < 5) {
        navigator.camera.getPicture((imageUri) => {
          this.convertImgToBase64(imageUri, (base64Img) => {
            this.imageSrc.push(base64Img);
          });
          this.numPictures += 1;
          this.emitImages();
        }, (error) => {
          // eslint-disable-next-line no-console
          console.debug(`Unable to obtain picture: ${error}`, 'app');
        }, options);
      } else {
        HiNotification.Alert(this.$t('General.TooManyPictures'));
      }
    },
    browserGetPicture() {
      const event = new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: true,
      });
      this.$refs.fileInput.dispatchEvent(event);
      this.sheetOpened = false;
    },
    // Convertir imagen a base64
    convertImgToBase64(url, callback, outputFormat) {
      let canvas = document.createElement('CANVAS');
      const ctx = canvas.getContext('2d');
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      // eslint-disable-next-line func-names
      img.onload = function () {
        canvas.height = img.height;
        canvas.width = img.width;
        ctx.drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL(outputFormat || 'image/jpeg');
        callback.call(this, dataURL);
        // Clean up
        canvas = null;
      };
      img.src = url;
    },
    emitImages() {
      this.$emit('images-changed', this.imageSrc);
    },
    openSheet() {
      this.sheetOpened = true;
    },
    onSelectFileBrowser() {
      const self = this;
      const input = this.$refs.fileInput;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageData = e.target.result;
        };
        this.getBase64ToFile(files[0]).then(
          (data) => {
            self.imageSrc.push(data);
            self.numPictures += 1;
            self.emitImages();
          },
        );
      }
    },
    getBase64ToFile(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
  },
};
</script>

<style lang="scss">
.photo-scouting {
  object-fit: cover;
  width: 100%;
  height: 200px;
  border-radius: 3px;
}

.main-take-picture {
  .content-select-picture {
    &__title {
      color: var(--his-oliva);
      font-size: 14px;
      margin-bottom: 5px;
      padding-left: 5px;
      display: block;
    }

    &__add-img {
      display: flex;
      align-items: center;
      justify-content: center;
      background: var(--his-lightsnow);
      border: 1px solid var(--his-platinum);
      border-radius: 8px;

      img {
        width: 32px;
        height: 32px;
      }
    }
  }
}
</style>
